export const fetchPaidInvoices = () => {
  return (dispatch, getState) => {
    const state = getState()
    const { organization, resident } = state

    dispatch({type: 'BEGIN_FETCH_PAID_INVOICES'})
    $.ajax({
      url: `/organizations/${organization.name}/residents/${resident.id}/paid_invoices.json`,
      success: (response) => {
        dispatch({type: 'SUCCESS_FETCH_PAID_INVOICES', payload: response })

      },
      errors: () => {
        dispatch({type: 'FAILED_FETCH_PAID_INVOICES'})

      }
    })
  }
}